import { oz } from '@weft/utils';
import { ObjectIdSchema, ApiDateSchema } from '../../primitives';
import { ReportJobInvocationTypesSchema, ReportJobStatusesSchema, ReportJobTypesSchema } from '../report-job';

export const ReportDataSchema = oz.object({
  id: ObjectIdSchema,
  status: ReportJobStatusesSchema,
  reportName: oz.string().optional(),
  type: ReportJobTypesSchema,
  invocationType: ReportJobInvocationTypesSchema,
  createdAt: ApiDateSchema,
});

export type ReportData = oz.infer<typeof ReportDataSchema>;